import { render, staticRenderFns } from "./taskOrder.vue?vue&type=template&id=0acf4735&scoped=true"
import script from "./taskOrder.vue?vue&type=script&lang=js"
export * from "./taskOrder.vue?vue&type=script&lang=js"
import style0 from "./taskOrder.vue?vue&type=style&index=0&id=0acf4735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf4735",
  null
  
)

export default component.exports